import { getContext } from 'configs/context';

import { PUBLISH_EVENT } from 'configs/constants';

const sendPremiumContentInfo = (isPremiumContent: boolean) =>
  getContext().handlers.publishEvent({
    event: PUBLISH_EVENT.PREMIUM_CONTENT_INFO,
    data: { isPremiumContent },
  });

export default sendPremiumContentInfo;
